import { Link } from "@remix-run/react";
import { CREDENTIAL_TYPE } from "@repo/shared";

import { CertificateCard } from "~/modules/Profile/Certificates/CertificateCard";
import { SAMPLE_CREDENTIAL } from "~/modules/Profile/Certificates/sampleCredential";
import { buildMeta, getCompanyFromMatches } from "~/utils/meta-helpers";

import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = ({ matches, location }) => {
  const company = getCompanyFromMatches(matches);
  return buildMeta({
    title: `Ejemplo de certificado | ${company}`,
    description:
      "Así se ve un certificado de AcademIA. Es un modelo: cada credencial real se comprueba con su código.",
    path: location.pathname,
  });
};

/**
 * /certificado — el EJEMPLO. Es a donde apuntan la home y la ficha de curso con "mirá cómo
 * queda un certificado", y por eso sobrevive a la url con código.
 *
 * No dictamina nada, a propósito: antes decía "certificado verificado / es auténtico" con
 * datos de muestra, o sea que el sitio declaraba auténtico a un ejemplo. El veredicto vive
 * en /certificado/:code, que pregunta al servidor. Acá sólo se muestra el objeto.
 */
export default function CertificateExamplePage() {
  return (
    <section className="landing-grain relative bg-landing-cream/70 px-5 py-16 backdrop-blur-[1px] sm:px-8 sm:py-20">
      <div className="relative mx-auto max-w-[820px]">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-landing-border bg-landing-white px-4 py-2 text-[13px] font-bold text-landing-muted">
            Ejemplo · datos de muestra
          </span>
          <h1 className="font-display mt-4 text-balance text-[clamp(24px,3.4vw,34px)] font-extrabold leading-tight tracking-tight text-landing-text">
            Así queda un certificado de AcademIA
          </h1>
          <p className="mx-auto mt-2 max-w-[52ch] text-[14.5px] leading-relaxed text-landing-muted">
            El nombre, el curso y el código de abajo son inventados. En uno real, ese código abre
            una página con los datos de quien lo recibió, tal como los registramos.
          </p>
        </div>

        {/* La MISMA tarjeta que recibe el alumno (y que copia el PDF), con datos de muestra y
            marca de agua: una captura suelta de esta página no pasa por credencial real. */}
        <CertificateCard
          variant="example"
          className="mt-10"
          {...SAMPLE_CREDENTIAL}
          type={CREDENTIAL_TYPE.CERTIFICADO}
        />

        <p className="mx-auto mt-8 max-w-[52ch] text-center text-[13px] leading-relaxed text-landing-muted">
          Cada curso indica en su ficha si entrega constancia o certificado. Las dos llevan código
          propio y se comprueban de la misma forma.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-[14px]">
          <Link
            to="/verificar"
            data-cuelume-hover="tick"
            data-cuelume-press
            className="font-bold text-landing-teal underline decoration-landing-teal/40 underline-offset-4 hover:decoration-landing-teal"
          >
            Tengo un código: quiero verificarlo
          </Link>
          <span className="text-landing-border">·</span>
          <Link
            to="/#cursos"
            data-cuelume-hover="tick"
            data-cuelume-press
            className="font-bold text-landing-red underline decoration-landing-red/30 underline-offset-4 hover:decoration-landing-red"
          >
            Quiero el mío: empezá gratis
          </Link>
        </div>
      </div>
    </section>
  );
}
